/* import __COLOCATED_TEMPLATE__ from './automation-rate-section.hbs'; */
/* RESPONSIBLE TEAM: team-ai-insights */
import Component from '@glimmer/component';
import type { ReportState } from 'embercom/components/reporting/custom/report/chart-card';
import { inject as service } from '@ember/service';
import type IntlService from 'ember-intl/services/intl';
import { action } from '@ember/object';
import type RouterService from '@ember/routing/router-service';

interface Signature {
  Args: {
    reportState: ReportState;
  };
}

export default class AutomationRateSection extends Component<Signature> {
  @service declare intl: IntlService;
  @service declare router: RouterService;

  get automationObjects() {
    return {
      numerator: {
        label: this.intl.t(
          'components.reporting.bespoke.fin-performance.automation-rate-section.label-resolved',
        ),
        barColorClass: 'bg-vis-mint-40',
        tooltipText: this.intl.t(
          'components.reporting.bespoke.fin-performance.automation-rate-section.tooltip-resolved-conversations',
        ),
        gapAfter: true,
      },
      denominator: {
        label: this.intl.t(
          'components.reporting.bespoke.fin-performance.automation-rate-section.label-total-volume',
        ),
        tooltipText: this.intl.t(
          'components.reporting.bespoke.fin-performance.automation-rate-section.tooltip-total-support-volume',
        ),
        barColorClass: 'bg-neutral-border-emphasis',
      },
    };
  }

  get resolutionObjects() {
    return {
      numerator: {
        label: this.intl.t(
          'components.reporting.bespoke.fin-performance.automation-rate-section.label-resolved',
        ),
        barColorClass: 'bg-vis-mint-40',
        tooltipText: this.intl.t(
          'components.reporting.bespoke.fin-performance.automation-rate-section.tooltip-resolved-conversations',
        ),
        gapAfter: true,
      },
      denominator: {
        label: this.intl.t(
          'components.reporting.bespoke.fin-performance.automation-rate-section.label-involved',
        ),
        barColorClass: 'bg-vis-mint-10',
        tooltipText: this.intl.t(
          'components.reporting.bespoke.fin-performance.automation-rate-section.tooltip-involved-conversations',
        ),
      },
    };
  }

  get involvementObjects() {
    return {
      numerator: {
        label: this.intl.t(
          'components.reporting.bespoke.fin-performance.automation-rate-section.label-involved',
        ),
        barColorClass: 'bg-vis-mint-10',
        tooltipText: this.intl.t(
          'components.reporting.bespoke.fin-performance.automation-rate-section.tooltip-involved-conversations',
        ),
        gapAfter: true,
      },
      denominator: {
        label: this.intl.t(
          'components.reporting.bespoke.fin-performance.automation-rate-section.label-total-volume',
        ),
        barColorClass: 'bg-neutral-border-emphasis',
        tooltipText: this.intl.t(
          'components.reporting.bespoke.fin-performance.automation-rate-section.tooltip-total-support-volume',
        ),
      },
    };
  }

  get automationRateChartDefinition() {
    return {
      visualization_type: 'counter',
      chart_series: [{ metric_id: 'fin.automation_rate' }],
    };
  }
  get resolutionRateChartDefinition() {
    return {
      visualization_type: 'counter',
      chart_series: [{ metric_id: 'fin.resolution_rate' }],
    };
  }
  get involvementRateChartDefinition() {
    return {
      visualization_type: 'counter',
      chart_series: [{ metric_id: 'fin.participation_rate' }],
    };
  }

  @action
  redirectToOptimize() {
    this.router.transitionTo('apps.app.automation.fin-ai-agent.analyze.optimize-suggestions');
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Reporting::Bespoke::FinPerformance::AutomationRateSection': typeof AutomationRateSection;
    'reporting/bespoke/fin-performance/automation-rate-section': typeof AutomationRateSection;
  }
}
